__webpack_require__.p = "/wp-content/plugins/cg-archive-shortcode/src/client/build/";